export function formatCount(value) {
  return new Intl.NumberFormat('es-AR').format(value ?? 0);
}

export function formatRelativeTime(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'hace unos segundos';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `hace ${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 48) return `hace ${hours} h`;
  const days = Math.floor(hours / 24);
  return `hace ${days} d`;
}

export function formatPercent(value) {
  if (value == null) return '—';
  return `${Number(value).toFixed(1)} %`;
}

export function formatMb(value) {
  if (value == null) return '—';
  return `${Number(value).toFixed(2)} MB`;
}

export function formatCurrency(value, currency = 'ARS') {
  if (value == null) return '—';
  try {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: currency === 'USD' ? 'USD' : 'ARS',
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `$ ${formatCount(value)}`;
  }
}
